export default {
  alertHeight: 0,
  accordionHeight: 0,
  searchPanelMobileOpen: false,
  mainMenuMobileOpen: false,
};
